export function setupSearchSelects() {
    if(document.querySelector('.search-select')) {
        Array.from(document.querySelectorAll('.search-select')).forEach(select => {
            const input = select.querySelector('.search-select__search-input');
            const dropdown = select.querySelector('.search-select__dropdown');
            const options = select.querySelectorAll('.search-select__tags input');
            const optionsLabels = select.querySelectorAll('.search-select__dropdown-item');
            const clearBtn = select.querySelector('.search-select__search-clear');

            input.addEventListener('focus', open);
            clearBtn.addEventListener('click', clear);

            input.addEventListener('input', search);

            Array.from(options).forEach(option => {
                option.addEventListener('input', clear);
            });

            function clear() {
                dropdown.classList.remove('search-select__dropdown--active');
                clearBtn.classList.remove('search-select__search-clear--active');
                input.value = "";    

                resetList();
            }

            function open() {
                dropdown.classList.add('search-select__dropdown--active');
                clearBtn.classList.add('search-select__search-clear--active');
            }

            function search() {
                const searchTerm = input.value;

                if(searchTerm.length > 0) {
                    const searchWords = searchTerm.trim().split(' ');

                    Array.from(optionsLabels).forEach(option => {     
                        let hasMatch = false;

                        searchWords.forEach(word => {
                            const searchRegEx = new RegExp(word, 'ig');
                            let matches = option.innerText.match(searchRegEx);

                            if(matches && matches.length > 0) {
                                hasMatch = true;
                                option.innerHTML = option.innerHTML.replaceAll(/\<span class\=\"js-highlight\"\>(.*?)\<\/span\>/gi, "$1").replaceAll(searchRegEx, '<span class="js-highlight">' + matches[0] + '</span>');  
                            }
                        });

                        if(!hasMatch) {
                            option.classList.add('js-no-match');
                        } else {
                            option.classList.remove('js-no-match');
                        }
                    })
                } else {
                    resetList();
                }    
            }

            function resetList() {
                Array.from(optionsLabels).forEach(option => {
                    option.classList.remove('js-no-match');
                    option.innerHTML = option.innerText;
                })
            }
        });
    }
}